<template>
  <v-app>
    <NavHeader
      v-if="isAuthenticated"
      :header="header"
      :sideTop="SideTop"
      :sideButton="SideButton"
      class="d-print-none"
    ></NavHeader>
    <unAthNav v-else class="d-print-none"></unAthNav>
    <v-main :class="colorPage">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>
import unAthNav from "@/components/coman/unAuthNavCMP";
import NavHeader from "@/components/util/AuthNav";
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import { EventBus } from "./main.js";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  mixins: [tokenMixin],
  components: {
    NavHeader,
    unAthNav,
  },
  data() {
    return {
      CurrentColor: "teal white--text",
      SeconColor: "grey",
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    header() {
      // UserBranch == 'company'
      if (this.UserInfo.UserBranch == "company") return "teal white--text";
      else return `${this.SeconColor} darken-1 white--text`;
    },
    SideTop() {
      if (this.UserInfo.UserBranch == "company") return "teal white--text";
      else return `${this.SeconColor} darken-2`;
    },
    SideButton() {
      if (this.UserInfo.UserBranch == "company") return "teal white--text";
      else return `${this.SeconColor} darken-1`;
    },
    colorPage: {
      get() {
        if (this.CurrentColor == "white") return this.CurrentColor;
        else if (!this.UserInfo) return "primary white--text";
        else if (this.UserInfo.UserBranch == "company")
          return "teal white--text";
        else return `${this.SeconColor} darken-1 white--text`;
      },
      set(color) {
        this.CurrentColor = color;
      },
    },
  },
  methods: {
    loadData() {
      // console.log(mapGetters(["CashSigns"]));
      this.$store.dispatch("SelectAll", {
        url: "/cashTypes",
        MutName: "SaveCashTypes",
      });
    },
    async pagTitle() {
      let titlePage = await localStorage.getItem("xisabiye");
      document.title = titlePage || "xisab-Haye";
      axios
        .post("/api-vi/login/ciw")
        .then(result => {
          // console.log(result);
          if (result.data) {
            let title = result.data;
            localStorage.setItem(
              "xisabiye",
              title.slice(0, title.indexOf("."))
            );
            document.title = title.slice(0, title.indexOf("."));
          } else document.title = "xisab-Haye";
        })
        .catch(() => {
          document.title = "xisab-Haye";
        });
    },
  },
  updated() {
    if (this.isAuthenticated) {
      this.loadData();
      this.$store.dispatch("loadBaraches");
    }
  },
  mounted() {
    EventBus.$on("PrintEvent", val => {
      if (val != true) this.colorPage = "white";
      else this.colorPage = "teal white--text";
      // console.log(value);
    });

    // this.pagTitle();
  },
  // created() {
  //   if (this.isAuthenticated) this.loadData();

  //   // console.log(process.env.NODE_ENV);
  // },
};
</script>
<style scoped>
.hideScroll {
  overflow: hidden;
  /* overflow-x: hidden; */
}
</style>
